'use client';

import { FormRenderer } from '@jlg-website/form/renderer/client';
import type { Answers, FormConfig, FormInput, FormLocale } from '@jlg-website/shared';
import type { FormVariant } from './type';
import { useLeadForm } from '@/hooks/use-lead-form';

type FormClientProps = {
  schema: FormInput;
  variant?: FormVariant;
  config?: FormConfig;
  locale?: FormLocale;
  /** Answers to pre-select, decoded from the URL server-side (see `answer-query`). */
  initialAnswers?: Answers;
};

export default function FormClient({
  schema,
  variant,
  config,
  locale,
  initialAnswers,
}: FormClientProps) {
  // Validators, marketing events and the submit path are shared with the mass-tort hero client.
  const {
    config: configWithValidators,
    handleSubmit,
    handleStepNext,
    handleReachLastStep,
  } = useLeadForm(schema, config);

  return (
    <FormRenderer
      schema={schema}
      config={configWithValidators}
      variant={variant}
      locale={locale}
      autoNext
      // Pre-selected from the URL token (server-decoded); with `autoNext`, a fully answered leading
      // step advances on its own.
      initialAnswers={initialAnswers}
      onSubmit={handleSubmit}
      onStepNext={handleStepNext}
      onReachLastStep={handleReachLastStep}
      enableNextOnValidate={false}
    />
  );
}
